import { BG_STYLES } from "@dehaat/dds";

export interface InsuredProduct {
  insurance_type_name: string;
  policy_start_at: string;
  policy_end_at: string;
  type_of_policy: string;
}

export interface Insurance {
  enrollment_no: string;
  cost_to_farmer: string;
  sum_insured: string;
  total_premium_amount: string;
  policy_order_details: {
    policy_status: POLICY_STATUS;
    total_premium_amount: string;
    sum_insured: string;
    group_insurance_product: InsuredProduct;
  };
  claim_details: [];
}

export interface InsuranceTypeCounts {
  "CROP INSURANCE": number;
}

export enum POLICY_STATUS {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
  NOTSTARTED = "Yet To Start",
}

export enum CLAIM_STATUS {
  AVAILABLE = "Claim Available",
  TO_BE_EVALUATED = "To Be Evaluated",
  NOT_ELIGIBLE = "Not Eligible",
  PROCESSED = "Claim Received",
  IN_PROCESS = "Claim In Process",
  UNDER_EVALUATION = "Under Evaluation",
}

export const POLICY_CARD_STATUS: Record<string, string> = {
  [POLICY_STATUS.ACTIVE]: "Policy Active",
  [POLICY_STATUS.INACTIVE]: "Risk Period Over",
  [POLICY_STATUS.NOTSTARTED]: "Policy Not Started",
};

export const POLICY_STATUS_BG_COLOR: Record<string, keyof typeof BG_STYLES> = {
  [POLICY_STATUS.ACTIVE]: "bgBlue100",
  [POLICY_STATUS.INACTIVE]: "bgNeutral70",
  [POLICY_STATUS.NOTSTARTED]: "bgYellow100",
};
